<template>
	<div id="app">
		<router-view :key="$route.fullPath"></router-view>

		<InstallApp />
	</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapMutations, mapGetters } from 'vuex'
import mixins from '@/mixins/mixins'
import InstallApp from './components/InstallApp'

export default {
	name: 'App',
	components: { InstallApp },
	mixins: [mixins],
	beforeMount() {
		this.loadMe()
	},
	mounted() {
		console.log(this.$installer)
	},

	computed: {
		...mapGetters(['isAuthenticated', 'loggedUser']),
	},
	methods: {
		...mapMutations(['logout', 'updateLoggedUser', 'savePosition']),

		loadMe() {
			console.log('loadMe', this.isAuthenticated)
			if (this.isAuthenticated) {
				this.$apollo
					.query({
						query: gql`
							query {
								sellerLogged {
									id
									name
									lastname
									email
									business
									points
									top
									avatar {
										id
										type
										urlThumb
									}
								}
							}
						`,
						fetchPolicy: 'no-cache',
					})
					.then((data) => {
						this.updateLoggedUser(data.data.sellerLogged)
					})
					.catch(() => {
						this.$router.push('/logout')
					})
			}
		},

		watchLocation() {
			if (this.isAuthenticated) {
				this.$watchLocation({ enableHighAccuracy: true, timeout: 5000 })
					.then((coordinates) => {
						this.savePosition({
							lat: coordinates.lat,
							lng: coordinates.lng,
						})

						// me aseguro de checkear la posicion del usuario una sola vez con respecto a la oficina. //solo en dashboard
						if (this.iHaveToCheckOfficePosition && this.loggedUser && this.$route.name == 'dashboard') {
							this.checkOfficeLocation(coordinates)
							this.iHaveToCheckOfficePosition = false
						}
					})
					.catch((err) => {
						console.log(err)
						// this.$toast.error('Debe aceptar los permisos de ubicación')
					})
			}
		},

		checkOfficeLocation(coordinates) {
			const distance = this.calcDistanceBetweenPositions(coordinates.lat, coordinates.lng, this.loggedUser.office.latlng.lat, this.loggedUser.office.latlng.lng)
			if (distance > 4) {
				// this.$toast.warning(`PENDIENTE, Está a mas de 5km de distancia de su oficina (${distance}), Consultar cambio de oficina. y poder editar los kilometros de distancia para comprobar.`)
				this.$refs.changeOffice.open()
			}
		},
	},
}
</script>
